module.exports = __webpack_public_path__ + "static/media/wave-square.a95b92ec.svg";